import { initialState } from "redux/initialState";
import { MillSelectorState, Mill } from "models";
import { MillSelectorActions } from "./MillSelector.actions";

export const millSelectorReducer = (
  state: MillSelectorState = initialState.millSelector,
  action: { type: string; payload: Mill[] | Mill | string },
) => {
  switch (action.type) {
    case MillSelectorActions.SetMills:
      const mills = action.payload as Mill[];
      const firstMill: Mill = mills[0];
      const firstLine = firstMill.lineIds ? firstMill.lineIds[0] : null;

      return {
        ...state,
        fetching: false,
        mills,
        selectedMill: firstMill,
        selectedLineId: firstLine,
      };

    case MillSelectorActions.SetSelectedMill:
      const selectedMill = action.payload as Mill;
      const selectedLineId = selectedMill.lineIds ? selectedMill.lineIds[0] : null;

      return { ...state, selectedMill, selectedLineId };

    case MillSelectorActions.SetSelectedLine:
      return { ...state, selectedLineId: action.payload as string };

    case MillSelectorActions.SetMillFetchFailed:
      return { ...state, fetching: false, didInvalidate: true };

    default:
      return state;
  }
};
